var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("transition-group", { attrs: { name: "slide-fade" } }, [
          _c(
            "div",
            {
              key: "checkSave",
              staticClass: "md-checkbox",
              staticStyle: { color: "#337ab7" },
              attrs: { id: "chkSalvarPerfil" },
            },
            [
              _c("input", {
                staticClass: "md-check",
                attrs: {
                  type: "checkbox",
                  id: "chkSalvar",
                  onclick: "ExibirCampoNomePerfil(this.checked)",
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "chkSalvar" } }, [
                _c("span", { staticClass: "inc" }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "check",
                  staticStyle: { "border-color": "#337ab7" },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "box",
                  staticStyle: { "border-color": "#337ab7" },
                }),
                _vm._v(
                  " Salvar filtros como perfil para consultas futuras.\n                "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              key: "saveFields",
              staticClass: "form-group form-md-line-input has-info",
              staticStyle: { "margin-top": "20px" },
            },
            [
              _c("div", { staticClass: "input-group input-group-sm " }, [
                _c("div", { staticClass: "input-group-control" }, [
                  _c("input", {
                    staticClass: "form-control input-sm",
                    staticStyle: { "border-bottom": "1px solid #337ab7" },
                    attrs: {
                      type: "text",
                      placeholder: "Ex: Perfil balancete completo",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticStyle: { color: "#337ab7" },
                      attrs: { for: "form_control_1" },
                    },
                    [_vm._v("Nome do perfil")]
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "input-group-btn btn-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn blue btn-outline outline",
                      attrs: { type: "button" },
                    },
                    [_vm._v("Salvar")]
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { key: "loadFields" }, [
            _c("hr"),
            _vm._v(" "),
            _c("label", { staticStyle: { color: "#337ab7" } }, [
              _vm._v("Selecionar perfil"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-group select2-bootstrap-prepend" },
              [
                _c("span", { staticClass: "input-group-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: {
                        type: "button",
                        "data-select2-open": "selPerfis",
                      },
                    },
                    [_c("span", { staticClass: "glyphicon glyphicon-list" })]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    staticClass:
                      "form-control select2 select2-hidden-accessible",
                    staticStyle: { width: "100%" },
                    attrs: {
                      id: "selPerfis",
                      name: "perfis",
                      tabindex: "-1",
                      "aria-hidden": "true",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0", selected: "" } }, [
                      _vm._v("-- Consulta customizada --"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "select2 select2-container select2-container--bootstrap select2-container--below",
                    staticStyle: { width: "100%" },
                    attrs: { dir: "ltr" },
                  },
                  [
                    _c("span", { staticClass: "selection" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "select2-selection select2-selection--single",
                          attrs: {
                            role: "combobox",
                            "aria-haspopup": "true",
                            "aria-expanded": "false",
                            tabindex: "-1",
                            "aria-labelledby": "select2-selPerfis-container",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "select2-selection__rendered",
                              attrs: {
                                id: "select2-selPerfis-container",
                                title: "-- Consulta customizada --",
                              },
                            },
                            [_vm._v("-- Consulta customizada --")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "select2-selection__arrow",
                              attrs: { role: "presentation" },
                            },
                            [_c("b", { attrs: { role: "presentation" } })]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "dropdown-wrapper",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "input-group-btn btn-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn blue btn-outline outline",
                      attrs: { type: "button" },
                    },
                    [_vm._v("Carregar")]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }